import "../scss/main.scss";

import 'focus-visible'

import Utils from "./inc/Utils";
import scrollToAnchor from "./inc/scrollToAnchor";
import menu from "./inc/menu";
import HeroArgument from "./blocks/hero-argument";
import Temoignages from "./blocks/temoignages";
import CarteTarif from "./blocks/carte-tarif";
import Accordeon from "./blocks/accordeon";
import AccordeonSimple from "./blocks/accordeon-simple";
import Slider from "./blocks/slider";
import Catalogue from "./blocks/catalogue";
import YoastFaq from "./blocks/yoast-faq";
import stickyCta from "./inc/sticky-cta";
import CopyClipboard from "./blocks/copy-clipboard";

jQuery(function ($) {
  document.documentElement.classList.remove("no-js");

  Utils($);
  scrollToAnchor($);

  menu($);

  HeroArgument($);
  Temoignages($);
  CarteTarif($);
  Accordeon($);
  AccordeonSimple($);
  Slider($);
  Catalogue($)
  YoastFaq($)
  stickyCta($);
  CopyClipboard($)
});
